import { memo, useState, useEffect } from "react";
import { ChatBot } from "@churchofjesuschrist/ccdops-chatbot";
import { get } from "@churchofjesuschrist/universal-env";
import { Link } from "react-router-dom";

const { OAUTH_COOKIE_NAME, CHATBOT_ENDPOINT } = get();

// see Chatbot docs for "Customizing Links"
const LinkComponent = ({ href, children }) => {
    const relative = href.replace(new URL(href).origin, "");

    return <Link to={relative}>{children}</Link>;
};

export const AiChatBot = memo(({ className, lang, linkComponent }) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 736);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 736);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    // see Chatbot docs for "Analytics"
    const pageData = {
        info: {
            siteName: "Gospel Library Online",
            language: { lang },
            // info.name will be built from the page URL if it is not provided.
        },
    };

    return (
        // See Chatbot docs for more information https://github.com/ICS-Eng/csp-chatbot-fe/blob/main/packages/ccdops-chatbot/README.md
        <ChatBot
            className={className}
            endpoint={CHATBOT_ENDPOINT}
            // 44px is the height of --mobile-navigation-height and 1 rem is the ChatBot default
            bottom={isMobile ? "calc(44px + 1rem)" : `1rem`}
            idCookieName={OAUTH_COOKIE_NAME}
            lang={lang}
            linkType={linkComponent}
            useDefaultStrings={true}
            doAnalytics={true}
            pageData={pageData}
            stream={true}
        />
    );
});

AiChatBot.displayName = "AiChatBot";

const AiChatBotContainer = (ownProps) => {
    return <AiChatBot {...ownProps} linkComponent={LinkComponent} />;
};

export default AiChatBotContainer;
